import React from 'react';
import { UploadCloud } from 'lucide-react';

// Sichtbarer Hinweis: Dateien irgendwo auf die Seite ziehen – die globale Ablage ordnet sie Mandant/Akte zu
export const AblageStreifen = ({ ziel, testId = 'ablage-streifen' }) => (
  <div className="flex flex-wrap items-center gap-3 rounded-xl border-2 border-dashed border-[#b8893d]/50 bg-[#fbf7f0] px-4 py-2.5 text-[12.5px] text-[#34536b]" data-testid={testId}>
    <UploadCloud className="w-4 h-4 text-[#b8893d] shrink-0" />
    <span className="flex-1 min-w-[12rem]">Dateien einfach auf diese Seite ziehen – sie landen automatisch bei <b className="text-[#1B3A5C]">{ziel}</b>. Rechnungen werden erkannt.</span>
    <button type="button" onClick={() => document.querySelector('[data-testid="ablage-datei"]')?.click()} className="h-8 px-3 rounded-lg bg-[#1B3A5C] text-white text-xs hover:bg-[#b8893d] transition-colors" data-testid={`${testId}-waehlen`}>Datei wählen</button>
  </div>
);

export default AblageStreifen;
